import { useTranslation } from "react-i18next";
import { useReseller } from "@/api/reseller-manager";
import { Button } from "@/components/ui/button";
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetFooter,
	SheetHeader,
	SheetTitle,
} from "@/components/ui/sheet";
import { Skeleton } from "@/components/ui/skeleton";
import { DetailView } from "./reseller-detail-view";

interface ResellerSheetProps {
	resellerId: number | null;
	onOpenChange: (open: boolean) => void;
	onRequestDelete: (resellerId: number) => void;
	deletePending?: boolean;
}

export function ResellerSheet({
	resellerId,
	onOpenChange,
	onRequestDelete,
	deletePending,
}: ResellerSheetProps) {
	const { t } = useTranslation();

	const { data, isLoading } = useReseller(resellerId ?? 0);
	const open = resellerId !== null;

	return (
		<Sheet open={open} onOpenChange={onOpenChange}>
			<SheetContent>
				<SheetHeader>
					<SheetTitle>{t("resellers.viewTitle")}</SheetTitle>
					<SheetDescription>{t("resellers.viewDescription")}</SheetDescription>
				</SheetHeader>

				<div className="flex flex-col gap-4 px-4 pb-4">
					{isLoading ? (
						<>
							<Skeleton className="h-4 w-3/4" />
							<Skeleton className="h-4 w-1/2" />
							<Skeleton className="h-4 w-2/3" />
						</>
					) : data ? (
						<DetailView data={data} />
					) : null}
				</div>

				{!isLoading && data && (
					<SheetFooter>
						<Button
							variant="destructive"
							className="w-full"
							disabled={deletePending}
							onClick={() => onRequestDelete(resellerId!)}
						>
							{deletePending ? t("resellers.deleting") : t("resellers.delete")}
						</Button>
					</SheetFooter>
				)}
			</SheetContent>
		</Sheet>
	);
}
